function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.274652 13.726C0.361133 13.8129 0.463869 13.8818 0.576976 13.9288C0.690083 13.9758 0.811338 14 0.933796 14C1.05625 14 1.17751 13.9758 1.29062 13.9288C1.40372 13.8818 1.50646 13.8129 1.59294 13.726L7.78219 7.52609C7.85123 7.45706 7.90601 7.37508 7.94339 7.28482C7.98076 7.19457 8 7.09781 8 7.0001C8 6.90239 7.98076 6.80563 7.94339 6.71538C7.90601 6.62512 7.85123 6.54313 7.78219 6.47411L1.59294 0.274184C1.22799 -0.0913957 0.6396 -0.0913957 0.27465 0.274184C-0.0902998 0.639763 -0.0902998 1.22917 0.27465 1.59475L5.66697 7.00383L0.267205 12.4129C-0.0902969 12.771 -0.0902987 13.3679 0.274652 13.726Z",
  fill: "#666666"
});
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/iconArrowRight.0874b707.svg";
export { ForwardRef as ReactComponent };